<template>
  <Cfg>
    <slot>
      <MechanicalWorkshop/>
    </slot>
  </Cfg>
</template>

<script>
import Cfg from '../configuration.vue'
import MechanicalWorkshop from './mechanicalworkshop.vue'

export default {
  name: 'mechanicalworkshop-conf',
  components: {
    Cfg,
    MechanicalWorkshop
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/mechanicalworkshop/mechanicalworkshop-conf.vue